export const getDefaultApplicantName = (applicantIndex?: number): string | undefined => {
  if (!applicantIndex) return;
  return `Applicant ${applicantIndex + 1}`;
};
